import { StyleColumn } from '@components/styles'
import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import PageBreadCrum from '../components/pageBreadCrumb'
import { fetchByKey } from '../fetch'
import AdminDefaultEditorForm from '../form'
import AdminDefaultSeoForm from '../seoForm'
const title = 'Privacy Policy'
const editorPageKey = 'privacyPolicy'
const seoPageKey = 'privacyPolicySeo'
const AdminPrivacyPolicy = () => {
  const { data: seo } = useSelector((state: any) => state.privacyPolicySeo)
  const { data: privacyPolicy } = useSelector(
    (state: any) => state.privacyPolicy,
  )
  useEffect(() => {
    if (!privacyPolicy?.id) {
      fetchByKey(editorPageKey)
    }
    if (!seo?.id) {
      fetchByKey(seoPageKey)
    }
  }, [])

  return (
    <StyleColumn>
      <PageBreadCrum
        title={title}
        onClick={() => {
          window.open('/#/privacy-policy', '_blank', 'noopener,noreferrer')
        }}
      />
      <AdminDefaultEditorForm
        pageKey={editorPageKey}
        title={title}
        data={privacyPolicy}
      />
      <AdminDefaultSeoForm
        data={seo}
        pageKey={seoPageKey}
        title={`${title} Seo`}
      />
    </StyleColumn>
  )
}
export default AdminPrivacyPolicy
